let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hMMly")).then(() => parcelRequire('6EG80'));